// extracted by mini-css-extract-plugin
export default {"newsfeed":"BO-z"};